/**
 * Regenerate-style options offered in the "Endurgera" menu.
 * Keys must match SUMMARY_STYLE_INSTRUCTIONS in app/api/ai_prompts.py.
 */
export type SummaryStyle = 'concise' | 'detailed' | 'bullets' | 'prose';

export interface SummaryStyleOption {
  style: SummaryStyle;
  label: string;
}

export const SUMMARY_STYLE_OPTIONS: SummaryStyleOption[] = [
  { style: 'concise', label: 'Gera hnitmiðaðri' },
  { style: 'detailed', label: 'Gera ítarlegri' },
  { style: 'bullets', label: 'Setja í punktaform' },
  { style: 'prose', label: 'Setja í samfelldan texta' },
];
